import {Injectable} from '@angular/core';
import {BaseDao} from '../../../base-dao';
import {DotNetServerPlugin} from '../../../models';
import {KluhManagerValidator} from '../../../validators/kluh-manager-validator';
import {R2CloudHttpApiService} from '../../../r2-cloud-http-api.service';

@Injectable({
  providedIn: 'root'
})
export class DotNetServerPluginDaoService extends BaseDao<DotNetServerPlugin> {

    constructor(http: R2CloudHttpApiService, validatorDAO: KluhManagerValidator) {
        super(http, validatorDAO, 'server-plugin');
    }
}
